import { MainPageConfig } from 'config/routeConfig'
import dynamic from 'next/dynamic'

import SearchService from 'components/main/_searchService'
import Statistics from 'components/_statistics'

const Services = dynamic(() => import('components/main/_services'))
const Helps = dynamic(() => import('components/main/_helps'))
const ReasonsForUse = dynamic(() => import('components/main/_reasonsForUse'))
const PriceCalculation = dynamic(() => import('components/main/_priceCalculation'))
const TopContractors = dynamic(() => import('components/_topContractors'))
const InviteToSignUp = dynamic(() => import('components/main/_inviteToSignUp'))


export default function Home() {

  return (
    <>
      <SearchService />
      <Statistics main />
      <InviteToSignUp />
      <Services />
      <Helps />
      <ReasonsForUse />
      <PriceCalculation />
      <TopContractors />
    </>
  )

}


Home.config = MainPageConfig